// extracted by mini-css-extract-plugin
export default {"arrowWhite":"style_arrowWhite__f0UM+","blackDot":"style_blackDot__D+0x6","forminfo":"style_forminfo__brhlM"};